import * as z from "zod";

const getParcelsForCheckoutFromOmsAutomationResultSchema_ = z.union([
  z.object({
    result: z.literal("converged"),
    selectedParcelIds: z.array(z.string()),
  }),
  z.object({
    result: z.literal("diverged"),
    bestEffortSelectedParcelIds: z.array(z.string()),
  }),
  z.object({
    result: z.literal("learned-preset"),
    selectedParcelIds: z.array(z.string()),
  }),
]);
export const getParcelsForCheckoutFromOmsAutomationResultSchema: z.ZodType<GetParcelsForCheckoutFromOmsAutomationResult> =
  getParcelsForCheckoutFromOmsAutomationResultSchema_;
export type GetParcelsForCheckoutFromOmsAutomationResult = z.infer<
  typeof getParcelsForCheckoutFromOmsAutomationResultSchema_
>;
